const state = {
  messageInfo: null,
  messageChangeNum: -1,
  allMessages: [],
  allMessagesChangeNum: -1,
};

const getters = {
  messageChange: (state) => state.messageChangeNum,
  allMessagesChange: (state) => state.allMessagesChangeNum,
};

const actions = {};

// const mutations = {
//     setMessage(state, msg){
//         state.messageInfo = msg;
//         state.messageChangeNum += 1;

//         if(msg.hasOwnProperty('type') && msg.type == 'error'){
//             console.log(msg)
//             if(msg.message.hasOwnProperty('message')){
//                 state.allMessages.push({'dt':new Date(), 'msg': msg.message.message});
//             }
//             else{
//                 let arr = msg.message.split('\n');
//                 if(arr.length > 1 && arr[0].indexOf(new Date().toDateString()) != 1){
//                     state.allMessages.push({'dt':arr[0], 'msg': arr[1]});
//                 }
//                 else{
//                     state.allMessages.push({'dt':new Date(), 'msg': msg.message.message});
//                 }
//             }
//             state.allMessagesChangeNum += 1;
//         }
//     },
//     deleteMessage(state, msgIndex){
//         state.allMessages.splice(msgIndex, 1);
//         state.allMessagesChangeNum += 1;
//     }
// }
const mutations = {
  setMessage(state, msg) {
    state.messageInfo = msg;
    state.messageChangeNum += 1;

    // msg 为空，直接结束
    if (!msg || typeof msg !== "object") return;

    // 判断是否是 error 类型
    if (
      Object.prototype.hasOwnProperty.call(msg, "type") &&
      msg.type === "error"
    ) {
      console.log(msg);

      let errorMsg = "";

      // 情况1：msg.message 是对象，例如 { message: "xxx" }
      if (msg.message && typeof msg.message === "object") {
        if (Object.prototype.hasOwnProperty.call(msg.message, "message")) {
          errorMsg = msg.message.message;
        } else {
          errorMsg = JSON.stringify(msg.message);
        }
      }

      // 情况2：msg.message 是字符串
      else if (typeof msg.message === "string") {
        const arr = msg.message.split("\n");

        if (
          arr.length > 1 &&
          arr[0].indexOf(new Date().toDateString()) !== -1
        ) {
          state.allMessages.push({
            dt: arr[0],
            msg: arr[1],
          });

          state.allMessagesChangeNum += 1;
          return;
        }

        errorMsg = msg.message;
      }

      // 情况3：没有 message
      else {
        errorMsg = "未知错误";
      }

      state.allMessages.push({
        dt: new Date(),
        msg: errorMsg,
      });

      state.allMessagesChangeNum += 1;
    }
  },

  deleteMessage(state, msgIndex) {
    state.allMessages.splice(msgIndex, 1);
    state.allMessagesChangeNum += 1;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
